/* eslint-disable import/extensions */
import TheMainLogo from '@/components/Platform/TheMainLogo';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';
import TheCustomerBasicData from '@/components/Platform/TheCustomerBasicData';
import CurrentHolidayListPopover from './CurrentHolidayListPopover';
import CallPlannerPopover from './CallPlannerPopover';
import ExpiryProjectsList from './ExpiryProjectsList';

// @vue/component
export default {
  name: 'TheHeader',

  components: {
    TheMainLogo,
    ShButton,
    ShUserAvatar,
    TheCustomerBasicData,
    CurrentHolidayListPopover,
    ExpiryProjectsList,
    CallPlannerPopover
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'medium',
    },
    holidayList: {
      type: Array,
      default: () => [],
    },
    agentsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    userData() {
      return this.user;
    },
  },

  methods: {
    handleLogout() {
      this.$auth.logoutFromPlatform();
    },
  },
};
